import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Label } from './ui/label';
import {
  plastisolProfileSystems,
  normalizePlastisolProfileSystem,
} from '../data/mockData';
import ColorPicker from './ColorPicker';
import ConfiguratorAdditionalItems from './ConfiguratorAdditionalItems';
import ProfileSystemPicker from './ProfileSystemPicker';
import { useTranslation } from '../context/TranslationContext';

/** RAL 9010 Reinwit — Plastisol Zetwerk exterior default */
export const PLATISOL_DEFAULT_EXTERIOR_COLOR = 'white';

const isPlastisolProfileSelected = (configProfileId, optionProfileId) =>
  normalizePlastisolProfileSystem(configProfileId) ===
  normalizePlastisolProfileSystem(optionProfileId);

const PlastisolOptionsPanel = ({
  config,
  onConfigChange,
  additionalItems,
  onAdditionalItemsChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <ProfileSystemPicker
        profileSystems={plastisolProfileSystems}
        config={config}
        onConfigChange={onConfigChange}
        title={t('options.profileSystem')}
        description={t('options.selectPlastisolProfile')}
        normalizeProfileId={normalizePlastisolProfileSystem}
        isProfileSelected={isPlastisolProfileSelected}
        translateName={(id, name) =>
          id === 'plastisol-zetwerk' ? t('options.plastisolZetwerk') : name
        }
        translateDescription={(id, description) =>
          id === 'plastisol-zetwerk' ? t('options.plastisolZetwerk') : description
        }
      />

      <Card>
        <CardHeader>
          <CardTitle>{t('options.exteriorColor')}</CardTitle>
          <CardDescription className="text-xs">
            {t('options.selectFromStandardColors')}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ColorPicker
            selectedColor={config.exteriorColor || PLATISOL_DEFAULT_EXTERIOR_COLOR}
            onColorChange={(colorId) => onConfigChange('exteriorColor', colorId)}
            showSearch={true}
            maxVisible={8}
          />
        </CardContent>
      </Card>

      {onAdditionalItemsChange ? (
        <ConfiguratorAdditionalItems
          items={additionalItems}
          onItemsChange={onAdditionalItemsChange}
          config={config}
          onConfigChange={onConfigChange}
        />
      ) : null}
    </div>
  );
};

export default PlastisolOptionsPanel;
